const convertToString = (dateValue) => {
    let stringVal;
    if (!dateValue || dateValue === 'No Date') {
        stringVal = '';
    } else {
        const options = { timeZone: "UTC" };
        stringVal = new Date(dateValue).toLocaleDateString('fr-CA', options);
    }
    return stringVal;
}


const formatForRules = (dateValue) => {
    const options = { timeZone: "UTC" };
    return new Date(dateValue).toLocaleDateString('en-US', options);
}

/**
 * 
 * @param field a field object from a rule that has been run. Is the result of QuickQuote so it should match that structure.
 * @param fields A list of scenario fields. Starts with the whole outer list but when recursing it
 *               will become the children fields of the last field
 * @returns the field's value. when recursing it will rebuild the object with formatted dates
 */
function convertToReadableDate(field, fields) {
    const currField = fields.find(f => f.name === field.name);
    // check to make sure that currField exists. Help to prevent error when a field is changed or removed
    if (currField) {
        // if the type of the current field is a date and it has a date value
        if (currField.type === 'date' && (field.value && field.value !== 'No Date')) {
            // convert it to a date
            field.value = formatForRules(field.value);
        // if the type of the current field is date but it doesn't have a valid date value
        } else if (currField.type === 'date') {
            // set it to the default 'No Date'
            field.value = 'No Date';
        // if current field has objects, or children
        } else if (currField.objects) {
            // for each child field
            if (field.children) {
                for (let child of field.children) {
                    // re-call the function using the child as the field and the parent field's 
                    // children as the scenario fields list
                    child = convertToReadableDate(child, currField.objects)
                }
            }
        }
    }
    return field;
}

const convertToNumber = (fields) => {
    // make an array to hold the updated fields
    const newFields = [];
    // for each field
    for (let field of fields) {
        // if the field is a date
        if (field.type === 'date') {
            // if the value is not blank then convert the date to number of ms UTC
            if (field.dateValue !== "") {
                field.dateValue = new Date(field.dateValue).getTime();
            // else set the value to null
            } else {
                field.dateValue = null;
            }
        // the field is an array or an object
        } else if (field.type === 'array' || field.type === 'object') {
            // run the function on all of the fields objects
            field.objects = convertToNumber(field.objects);
        }
        // push the updated field to the array of updated fields
        newFields.push(field); 
    }
    // return the updated fields
    return newFields;
}

module.exports = {
    convertToString,
    formatForRules,
    convertToNumber,
    convertToReadableDate
}